import { API_GET_REFRESH_TOKEN, APIGetRefreshTokenType, APIResponseRefreshTokenType } from "../services/APIAuthorizationService"
import { ACCESS_TOKEN_EXPIRED, APICall, INTERNAL_SERVER_ERROR, UNAUTHORIZED } from "../services/APIService"

export const getRefreshToken = async () => {
    const accessToken: string | null = window.localStorage.getItem("accessToken")

    if(accessToken)
    {
        const requestBody: APIGetRefreshTokenType = {
            accessToken: accessToken
        }

        try
        {
            const response = await APICall(API_GET_REFRESH_TOKEN, 'POST', requestBody)

            if(response.httpStatus === "OK"){
                const responseData: APIResponseRefreshTokenType = response.data

                window.localStorage.setItem("accessToken", responseData.accessToken)
                console.log('accessToken: ', response.data.accessToken)
            }
            else if(response.errorCode === INTERNAL_SERVER_ERROR){
                console.log("failed getting refresh token")
            }
            else if(response.errorCode === ACCESS_TOKEN_EXPIRED){
                console.log("session expired")
                window.localStorage.clear()
                window.location.href = '/'
            }
            else if(response.errorCode === UNAUTHORIZED){
                console.log("invalid token")
                window.localStorage.clear()
                window.location.href = '/'
            }
        }
        catch(error)
        {
            console.log("server not responding")
        }
    }
    else
    {
        window.localStorage.clear()
        window.location.href = '/'
    }
}